var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ikas-channel-form", attrs: { id: "CreateIkasChannel" } },
    [
      _c(
        "div",
        { staticClass: "header" },
        [_c("IkasIcon", { staticClass: "ikas-icon" })],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Domain")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.domain,
              expression: "form.domain",
            },
          ],
          staticClass: "input",
          attrs: {
            type: "text",
            placeholder: "Domain adresinizi giriniz",
            autocomplete: "off",
          },
          domProps: { value: _vm.form.domain },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "domain", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "label" }, [_vm._v("Client ID")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.client_id,
              expression: "form.client_id",
            },
          ],
          staticClass: "input",
          attrs: {
            type: "text",
            placeholder: "Client ID",
            autocomplete: "off",
          },
          domProps: { value: _vm.form.client_id },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "client_id", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "label" }, [_vm._v("Client Secret")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.client_secret,
              expression: "form.client_secret",
            },
          ],
          staticClass: "input",
          attrs: {
            type: "text",
            placeholder: "Client Secret",
            autocomplete: "off",
          },
          domProps: { value: _vm.form.client_secret },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "client_secret", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "btn cancel",
            attrs: { type: "button" },
            on: { click: _vm.handleCancel },
          },
          [_vm._v("Vazgeç")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn primary",
            attrs: { type: "button", disabled: _vm.loading },
            on: { click: _vm.handleSubmit },
          },
          [
            _vm.loading
              ? _c("span", [_vm._v("Bağlanıyor...")])
              : _c("span", [_vm._v("Bağlan")]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "description" }, [
      _vm._v("\n        İkas panel URL'nizdeki\n        "),
      _c("span", { staticClass: "url" }, [
        _vm._v("https://"),
        _c("span", { staticClass: "highlight" }, [_vm._v("example")]),
        _vm._v(".myikas.com/"),
      ]),
      _vm._v("\n        kısmını domain alanına yazmalısınız.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }